var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"el",staticClass:"l-ss-c-lazy-load-anchor",staticStyle:{"height":"92px"}})}
var staticRenderFns = []

export { render, staticRenderFns }